// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { fetchCityList } from '../api/devices'
import { message } from 'antd'

export interface ICity {
  id: number
  name: string
  longitude: number
  latitude: number
  enabled: boolean
  timezone: string
  country: string
  continent: string
}

export interface ICityState {
  cityList: ICity[]
  current: ICity
  cityMap: { [id: string]: ICity }
  disabled: boolean
}

const DEFAULT_CITY = {
  id: 10,
  name: 'Jakarta',
  longitude: 106.845253,
  latitude: -6.211594,
  enabled: true,
  continent: 'Asia',
  country:'Indonesia'
}
export const city = {
  state: {
    cityList: [],
    current: null,
    cityMap: null,
    disabled: false
  } as ICityState,
  reducers: {
    updateCityList: (state: ICityState, cityList: ICity[]) => {
      const map = {}
      cityList.forEach(d => {
        map[d.id] = d
      })
      return {
        ...state,
        cityList,
        cityMap: map
      }
    },
    setCurrentCity: (state: ICityState, current: ICity) => ({
      ...state,
      current
    }),
    setCityStatus:(state: ICityState, status: boolean) => ({
      ...state,
      disabled: status
    })
  },
  effects: dispatch => ({
    async fetchCityList ({ silence }, rootState) {
      const showErrorTip = !silence
      try {
        const res = await fetchCityList()
        if (res.cities) {
          const cities = res.cities
          dispatch.city.updateCityList(cities)
          if (!rootState.city.current) {
            dispatch.city.setCurrentCity(cities[0])
          }
        } else {
          showErrorTip && message.warning('City List is invalid!!!!!')
        }
      } catch (e) {
        showErrorTip && message.error('fetch city list Error:' + e.toString())
      }
    },
    async onCityChange (cityId, rootState) {
      const current = rootState.city.cityList.filter(x => x.id === cityId)[0]
      await dispatch.jobList.setPagination({ current: 1, pageSize: 10 })
      await dispatch.city.setCurrentCity(current)
      await dispatch.map.setDefaultCenter()
    }
  })
}
